import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  /** Largura em px no desktop (default 480). */
  width?: number;
}

export function Drawer({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  width = 480,
}: DrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-ink-primary/30 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          style={{ width: `min(100vw, ${width}px)` }}
          className={clsx(
            'fixed inset-y-0 right-0 flex flex-col',
            'border-l border-border bg-surface shadow-lg',
            'data-[state=open]:animate-in data-[state=closed]:animate-out',
            'data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right',
            'duration-200'
          )}
        >
          <div className="flex items-start justify-between p-5 border-b border-border">
            <div>
              <Dialog.Title className="font-serif text-lg font-semibold text-ink-primary">
                {title}
              </Dialog.Title>
              {description && (
                <Dialog.Description className="text-sm text-ink-secondary mt-1">
                  {description}
                </Dialog.Description>
              )}
            </div>
            <Dialog.Close
              className="text-ink-tertiary hover:text-ink-primary transition-colors"
              aria-label="Fechar"
            >
              <X size={18} />
            </Dialog.Close>
          </div>
          <div className="flex-1 overflow-y-auto p-5">{children}</div>
          {footer && (
            <div className="flex items-center justify-end gap-2 p-5 border-t border-border">
              {footer}
            </div>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
